import { isAxiosError } from 'shared/api/isAxiosError'
import { ErrorResponse, ParsedErrorResponse, parseErrorResponse } from '../shared/api/parseAxiosTransitErrorResponse'
import { isApiError } from './ApiError'

function parseError(error: Error | undefined) {
  if (!error) return { status: null, errorResponse: null }

  let status: number | undefined
  let errorResponse: ParsedErrorResponse | undefined
  if (isApiError(error)) {
    status = error.status
    errorResponse = parseErrorResponse(error.details as ErrorResponse, error.status)
  }

  if (isAxiosError<ErrorResponse>(error)) {
    status = error.response?.status
    errorResponse = parseErrorResponse(error.response?.data, error.response?.status)
  }
  return {
    status,
    errorResponse,
  }
}

export default parseError
